interface ElementInfo {
    elementType: ElementType;
    roundsRemaining: number;
    color: string;
}
